import { useQuery } from "@tanstack/react-query";
import { useApi } from "src/api";

export const storePlanogramReviewStorePogQueryKey = (storePogId: number) => [
  "store-planogram-review",
  "store-pog",
  storePogId,
];

export const useStorePlanogramReviewStorePogQuery = (
  storePogId: number,
  hasStorePogData: boolean,
) => {
  const { getMerchflowStorePogApi } = useApi();

  return useQuery({
    queryKey: storePlanogramReviewStorePogQueryKey(storePogId),
    queryFn: () => getMerchflowStorePogApi(storePogId),
    enabled: !hasStorePogData,
  });
};
